import { AText } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { SPORT_IDS } from '../../../../../../constants';
import { useEventTimerCounters } from '../../../../../../hooks/useTimerCounter';
import { useEventFields } from '../../../../../../store';
import { EVENT_RESULT_PENALTY } from '../../../../../Score/constants';
import TimerCounter from '../../../../../TimerCounter';

const EventStateTimer = ({ emptyStateText, eventId }) => {
  const { t } = useI18n();
  const { eventTimer, eventStatusType, eventResultId, sportId } =
    useEventFields({
      eventId,
      fields: ['eventTimer', 'eventStatusType', 'eventResultId', 'sportId']
    });
  const timerCounters = useEventTimerCounters(eventTimer);

  if (
    (sportId === SPORT_IDS.WATER_POLO_GAME &&
      eventResultId === EVENT_RESULT_PENALTY) ||
    (sportId === SPORT_IDS.PICKLEBALL && eventStatusType === 'inprogress')
  ) {
    return (
      <AText size="s" breed="B" color="line_txt_1">
        {t('sportsBook.eventState.live')}
      </AText>
    );
  }

  return eventTimer ? (
    <AText size="s" breed="B" color="line_txt_1">
      <TimerCounter {...timerCounters} />
    </AText>
  ) : (
    (Boolean(emptyStateText) || Boolean(eventStatusType)) && (
      <AText size="s" breed="B" color="line_txt_1">
        {emptyStateText !== ''
          ? emptyStateText
          : t(`sportsBook.eventState.${eventStatusType}`)}
      </AText>
    )
  );
};

export default EventStateTimer;
